import { render, staticRenderFns } from "./RideitInvitationsDialog.vue?vue&type=template&id=85508c24&scoped=true"
import script from "./RideitInvitationsDialog.vue?vue&type=script&lang=ts"
export * from "./RideitInvitationsDialog.vue?vue&type=script&lang=ts"
import style0 from "./RideitInvitationsDialog.vue?vue&type=style&index=0&id=85508c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85508c24",
  null
  
)

export default component.exports